import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

/*
 * Organizations Controller with Reflex support
 * Handles search functionality for organizations index view
 */
export default class extends Controller {
  static targets = ["searchInput"];

  connect() {
    StimulusReflex.register(this);
    console.log("OrganizationsController connected");
  }

  // Called when user types in search input
  search() {
    const query = this.searchInputTarget.value.trim();

    // Don't search if query is too short
    if (query.length < 2) {
      return;
    }

    // Set the query in the dataset for the reflex to access
    this.element.dataset.query = query;

    // Trigger the reflex to search on the server
    this.stimulate("Organizations#search");
  }

  // Reflex lifecycle methods
  beforeSearch() {
    // Add loading state if needed
    console.log("Searching organizations...");
  }

  searchSuccess() {
    // Remove loading state if needed
    console.log("Organizations search completed");
  }

  searchError(error) {
    console.error("Organizations search error:", error);
  }
}
